import { RouteRecordRaw } from 'vue-router';

export const emailRoutes: RouteRecordRaw[] = [
  {
    path: '/email',
    name: 'email',
    component: () => import(/* webpackChunkName: 'email' */ './email.vue'),
  },
];
